import store from '@/store'
import authenticationService from '@/services/authentication'

const beforeEnter = (to, from, next) => {
  const { cpf, identifier } = store.state.authentication
  if (!cpf && !identifier) next({ name: 'Login' })
  else next()
}

export default {
  path: '/login',
  component: () => import('@/views/Login/Login.vue'),
  beforeEnter: (to, from, next) => {
    if (authenticationService.isAuthenticated()) next({ name: 'agendamentos' })
    else next()
  },
  children: [
    {
      name: 'Login',
      path: '',
      component: () => import('@/views/Login/Cpf.vue')
    },
    {
      name: 'Senha',
      path: 'senha',
      component: () => import('@/views/Login/Senha.vue'),
      beforeEnter
    },
    {
      name: 'Completar Cadastro',
      path: 'completar-cadastro',
      component: () => import('@/views/Login/CompletarCadastro.vue'),
      beforeEnter
    },
    {
      name: 'Recuperar Senha',
      path: 'recuperar-senha',
      component: () => import('@/views/Login/RecuperarSenha.vue')
    },
    {
      name: 'Redefinir Senha',
      path: 'redefinir-senha',
      component: () => import('@/views/Login/RedefinirSenha.vue')
    },
  ]
}
